import '../../css/pages/home.pcss';
import Home from './classes/home';

import $ from 'jquery';
window.$ = $;

const home = new Home();
window.APP.setCurrentPage(home);
